import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useEffect, useState } from 'react';

import { userQuery } from '../queries/userQuery';

import { getDateFnsLocale } from './dateUtils';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);

export const useFormattedDateLocale = (date: string) => {
	const { data: currentUser } = useQuery(userQuery);
	const [formattedDate, setFormattedDate] = useState('');
	const locale = getDateFnsLocale(currentUser?.language || 'en-US');

	useEffect(() => {
		dayjs.locale(locale);
		setFormattedDate(dayjs(date).format('MMM Do YYYY, h:mm:ss a'));
	}, [currentUser?.language, date, locale]);

	return formattedDate;
};
